import AddIp from "./AddIp";

export default AddIp;